import type { ReactNode } from "react";

import { cn } from "~/lib/utils";

export function SettingsPanel(props: { children: ReactNode; className?: string }) {
  return (
    <div className={cn("flex w-full min-w-0 flex-col gap-5", props.className)}>
      {props.children}
    </div>
  );
}

export function SettingsPageHeader(props: {
  actions?: ReactNode;
  description: string;
  title: string;
}) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0 space-y-1">
        <h2 className="text-base font-semibold tracking-tight text-foreground">{props.title}</h2>
        <p className="text-sm text-muted-foreground">{props.description}</p>
      </div>
      {props.actions ? (
        <div className="flex flex-wrap items-center gap-2">{props.actions}</div>
      ) : null}
    </header>
  );
}

export function SettingsSection(props: {
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  description?: string;
  /** When true, body has no padding (tables/lists that flush to edges). */
  flush?: boolean;
  title: string;
}) {
  return (
    <section
      className={cn("overflow-hidden rounded-xl border border-border bg-card", props.className)}
    >
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-border/70 px-5 py-4">
        <div className="min-w-0">
          <h3 className="text-sm font-medium text-foreground">{props.title}</h3>
          {props.description ? (
            <p className="mt-1 text-xs text-muted-foreground">{props.description}</p>
          ) : null}
        </div>
        {props.actions ? <div className="shrink-0">{props.actions}</div> : null}
      </div>
      <div className={props.flush ? undefined : "p-5"}>{props.children}</div>
    </section>
  );
}
